import { AVAILABILITY_OPTIONS, VOLUNTEER_AREAS } from "../data/site";
import { SectionEyebrow } from "../components/SectionEyebrow";
import { useVolunteerForm } from "../hooks/useVolunteerForm";
import { VolunteerHero, InternationalSection } from "../components/volunteer/VolunteerHero";
import { VolunteerForm, VolunteerSuccess } from "../components/volunteer/VolunteerForm";

export default function Voluntariado() {
    const { form, set, toggleArea, loading, submitted, handleSubmit, reset } = useVolunteerForm();

    return (
        <>
            <VolunteerHero />
            <InternationalSection />

            <section className="py-20 lg:py-28 bg-white" data-testid="volunteer-form-section" id="formulario">
                <div className="container-fe max-w-3xl">
                    <SectionEyebrow>Inscripción</SectionEyebrow>
                    <h2 className="mt-4 font-display font-bold text-3xl lg:text-5xl text-brand-navy leading-tight">
                        Cuéntanos quién eres.
                    </h2>
                    <p className="mt-4 text-muted-foreground text-lg">
                        Diligencia el formulario y nuestro equipo de coordinación te contactará en menos de 5 días hábiles.
                    </p>

                    {submitted ? (
                        <VolunteerSuccess onReset={reset} />
                    ) : (
                        <VolunteerForm
                            form={form}
                            set={set}
                            toggleArea={toggleArea}
                            loading={loading}
                            onSubmit={handleSubmit}
                            areas={VOLUNTEER_AREAS}
                            availability={AVAILABILITY_OPTIONS}
                        />
                    )}
                </div>
            </section>
        </>
    );
}
